module.exports = __webpack_public_path__ + "static/media/KULO_02.d3851bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/Background/KULO_02.png
// module id = 699
// module chunks = 0